export default "__VITE_ASSET__4qfIxSay__"